import React from 'react';
import { routes } from './routes';
import Layouts from './layouts';

const defaultLayoutKey = 'Layout1';

class App extends React.Component{
    
    constructor(props) {
        super(props);
        
        this.state = {
            // set desired global layout here in ComponentToRender
            ComponentToRender: Layouts[defaultLayoutKey],
            user: {}
        };
    }
    
    static getDerivedStateFromProps(nextProps, prevState){
        var filterRoutes = routes.filter(rte => rte.path === nextProps.history.location.pathname);
        if (filterRoutes && filterRoutes.length === 1 && filterRoutes[0].layout) {
            return { ComponentToRender: Layouts[filterRoutes[0].layout] };
        }
        else return null;
    }
    
    render() {
        var { ComponentToRender } = this.state;
        return (
            <ComponentToRender />
        );
    }
}

export default App;
